import { Button, ButtonProps } from "@mui/material";

import FilterListIcon from '@mui/icons-material/FilterList';
import AddIcon from '@mui/icons-material/Add';
import { useOpenModal } from "@/components/modal";

export function HeaderAddButton({ ...props }: ButtonProps) {
    return <Button size="small" variant="outlined" startIcon={<AddIcon />} {...props}>
        Agregar
    </Button>
}


export function HeaderFilterButton({
    ...props
}: ButtonProps) {
    const openModal = useOpenModal();

    return <Button size="small" startIcon={<FilterListIcon />} onClick={(e)=>{
        props.onClick&&props.onClick(e);
        if(!e.defaultPrevented) openModal("filterModal")
    }} {...props}>
        Filtros
    </Button>
}